class APIS {
	apis() {
		return {
			notificationsGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/get-all'
			},
			notificationsGetUnread: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/get-unread'
			},
			notificationsMarkAsRead: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/mark-as-read'
			},
			notificationsMarkMultipleAsRead: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/mark-multiple-as-read'
			},
			notificationsMarkAllAsRead: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/mark-all-as-read'
			},
			notificationsGetUnreadCount: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/get-unread-count'
			},
			notificationsGetByChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/notifications/get-by-channel'
			}
		};
	}
}

export default new APIS();
